/* ═══════════════════════════════════════════════
   SOLÈA — MAIN JAVASCRIPT
   ═══════════════════════════════════════════════ */

/* ── Cursor glow ── */
const cg = document.getElementById('cg');
if (cg) {
  document.addEventListener('mousemove', e => {
    cg.style.left = e.clientX + 'px';
    cg.style.top = e.clientY + 'px';
  });
}

/* ── Hamburger menu ── */
const hamburger = document.getElementById('hamburger');
const navLinks = document.getElementById('navLinks');
if (hamburger && navLinks) {
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('open');
    navLinks.classList.toggle('open');
  });
  navLinks.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    hamburger.classList.remove('open');
    navLinks.classList.remove('open');
  }));
}

/* ── Nav scroll shadow ── */
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 30), { passive: true });
}

/* ── Scroll reveal ── */
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('visible');
    io.unobserve(e.target);
  });
}, { threshold: 0.12 });
document.querySelectorAll('.sr').forEach(el => io.observe(el));

/* ── Steps line ── */
const lineIO = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); lineIO.unobserve(e.target); } });
}, { threshold: 0.3 });
const stepsLine = document.getElementById('stepsLine');
if (stepsLine) lineIO.observe(stepsLine);

/* ── Features list ── */
const featIO = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); featIO.unobserve(e.target); } });
}, { threshold: 0.2 });
const feat = document.getElementById('features');
if (feat) featIO.observe(feat);

/* ── Parallax hero ── */
const px = document.getElementById('parallax');
if (px) {
  window.addEventListener('scroll', () => {
    if (scrollY < window.innerHeight * 2) px.style.transform = `translateY(${scrollY * 0.08}px)`;
  }, { passive: true });
}

/* ════════════════════════════════
   OPENING CANVAS ANIMATION
   ════════════════════════════════ */
(function () {
  const canvas = document.getElementById('openingCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function resize() {
    const section = canvas.closest('.opening') || canvas.parentElement.parentElement;
    canvas.width = section.offsetWidth;
    canvas.height = section.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function drawPaw(x, y, scale, alpha, rotation) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation);
    ctx.globalAlpha = alpha;
    ctx.fillStyle = 'rgba(192,133,82,1)';
    ctx.beginPath(); ctx.ellipse(0, scale * 7, scale * 8, scale * 6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(-scale * 7, -scale * 1, scale * 4, scale * 5.5, -0.3, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(scale * 7, -scale * 1, scale * 4, scale * 5.5, 0.3, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(-scale * 3.5, -scale * 8, scale * 3.5, scale * 4.5, -0.1, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(scale * 3.5, -scale * 8, scale * 3.5, scale * 4.5, 0.1, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  }

  function makePaw() {
    return {
      x: Math.random() * canvas.width,
      y: canvas.height + 60 + Math.random() * 200,
      scale: Math.random() * 0.8 + 0.3,
      speed: Math.random() * 0.35 + 0.15,
      alpha: Math.random() * 0.13 + 0.04,
      drift: (Math.random() - 0.5) * 0.25,
      rot: (Math.random() - 0.5) * 0.8
    };
  }
  const paws = Array.from({ length: 22 }, () => {
    const p = makePaw();
    p.y = Math.random() * canvas.height;
    return p;
  });

  function makeBokeh() {
    return {
      ox: Math.random() * canvas.width,
      oy: Math.random() * canvas.height,
      r: Math.random() * 80 + 25,
      alpha: Math.random() * 0.08 + 0.02,
      angle: Math.random() * Math.PI * 2,
      speed: Math.random() * 0.008 + 0.003,
      rx: Math.random() * 50 + 15,
      ry: Math.random() * 35 + 10,
      color: Math.random() > 0.5 ? '192,133,82' : '184,149,58'
    };
  }
  const bokehs = Array.from({ length: 14 }, makeBokeh);
  let gradT = 0;

  function frame() {
    const W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    gradT += 0.004;
    const gx = W * (0.3 + Math.sin(gradT) * 0.15);
    const gy = H * (0.45 + Math.cos(gradT * 0.8) * 0.18);
    const g1 = ctx.createRadialGradient(gx, gy, 0, gx, gy, W * 0.8);
    g1.addColorStop(0, 'rgba(100,58,22,0.35)');
    g1.addColorStop(0.5, 'rgba(60,36,14,0.18)');
    g1.addColorStop(1, 'rgba(20,10,4,0)');
    ctx.fillStyle = g1; ctx.fillRect(0, 0, W, H);
    const g2 = ctx.createRadialGradient(W - gx, H - gy, 0, W - gx, H - gy, W * 0.6);
    g2.addColorStop(0, 'rgba(184,120,40,0.12)');
    g2.addColorStop(1, 'rgba(184,120,40,0)');
    ctx.fillStyle = g2; ctx.fillRect(0, 0, W, H);
    bokehs.forEach(b => {
      b.angle += b.speed;
      const bx = b.ox + Math.sin(b.angle) * b.rx;
      const by = b.oy + Math.cos(b.angle * 0.7) * b.ry;
      const bg = ctx.createRadialGradient(bx, by, 0, bx, by, b.r);
      bg.addColorStop(0, `rgba(${b.color},${b.alpha})`);
      bg.addColorStop(1, `rgba(${b.color},0)`);
      ctx.beginPath(); ctx.arc(bx, by, b.r, 0, Math.PI * 2);
      ctx.fillStyle = bg; ctx.fill();
    });
    paws.forEach(p => {
      if (!reduced) { p.y -= p.speed; p.x += p.drift; }
      if (p.y < -80) { Object.assign(p, makePaw()); }
      drawPaw(p.x, p.y, p.scale, p.alpha, p.rot);
    });
    requestAnimationFrame(frame);
  }
  frame();
})();

/* ════════════════════════════════
   PRODUCT PAGE
   ════════════════════════════════ */

/* Image switcher */
const productImgEl = document.getElementById('mainProductImg');
if (productImgEl) {
  productImgEl.style.transition = 'opacity 180ms ease';
}

function setMainImg(src, alt) {
  const img = document.getElementById('mainProductImg');
  if (!img) return;
  img.style.opacity = '0';
  setTimeout(() => {
    img.src = src;
    img.srcset = '';
    img.removeAttribute('srcset');
    if (alt) img.alt = alt;
    img.style.opacity = '1';
  }, 180);
}

const colorImgMap = {
  0: 0, 1: 1, 2: 2
};

function selectColor(el) {
  document.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  const color = el.dataset.color;
  const nameEl = document.getElementById('colorName');
  if (nameEl) nameEl.textContent = color;
  const src = el.dataset.img;
  setMainImg(src, 'Cornice ' + color);
  const idx = parseInt(el.dataset.idx || '0');
  const thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(t => t.classList.remove('active'));
  if (thumbs[idx]) thumbs[idx].classList.add('active');
  const colorInput = document.getElementById('selectedColorInput');
  if (colorInput) colorInput.value = color;
}

function switchImg(el, src, alt) {
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  setMainImg(src, alt);
  document.querySelectorAll('.swatch').forEach(s => {
    if (s.dataset.img === src) {
      s.classList.add('active');
      const nameEl = document.getElementById('colorName');
      if (nameEl) nameEl.textContent = s.dataset.color;
    } else {
      s.classList.remove('active');
    }
  });
}

/* Bundle selector */
const COLORS = ['Bianca', 'Legno naturale', 'Nera'];

function renderBundleColors(qty) {
  const wrap = document.getElementById('bundleColorsWrap');
  const pickers = document.getElementById('bundleColorPickers');
  const inputs = document.getElementById('bundleColorInputs');
  if (!wrap || !pickers || !inputs) return;
  if (qty <= 1) { wrap.style.display = 'none'; inputs.innerHTML = ''; return; }
  wrap.style.display = 'block';
  pickers.innerHTML = '';
  inputs.innerHTML = '';
  for (let i = 1; i <= qty; i++) {
    const row = document.createElement('div');
    row.className = 'bundle-color-row';
    row.innerHTML = `<span class="bundle-color-label">Cornice ${i}</span><div class="bundle-color-swatches">${COLORS.map((c, idx) => `<button type="button" class="bundle-swatch${idx===0?' active':''}" data-color="${c}" data-item="${i}" onclick="selectBundleColor(this,${i})">${c}</button>`).join('')}</div>`;
    pickers.appendChild(row);
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = `properties[Colore cornice ${i}]`;
    hidden.id = `bundle-color-input-${i}`;
    hidden.value = COLORS[0];
    inputs.appendChild(hidden);
  }
}

function selectBundleColor(el, item) {
  el.closest('.bundle-color-swatches').querySelectorAll('.bundle-swatch').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  const input = document.getElementById(`bundle-color-input-${item}`);
  if (input) input.value = el.dataset.color;
}

function selectBundle(el) {
  document.querySelectorAll('.bundle-option').forEach(b => b.classList.remove('active'));
  el.classList.add('active');
  const variantId = el.dataset.variantId;
  const qty = parseInt(el.dataset.quantity || '1');
  // Aggiorna l'ID variante nel form (prezzo reale Shopify)
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantId) variantInput.value = variantId;
  // Bundle ha sempre qty=1 (il prezzo è già nel variant)
  const qtyInput = document.getElementById('qty-input');
  if (qtyInput) qtyInput.value = 1;
  // Aggiorna testo pulsanti con il prezzo visivo
  const priceEl = el.querySelector('.bundle-price');
  const priceText = priceEl ? priceEl.textContent.trim() : '';
  const btnBuy = document.getElementById('btnBuy');
  if (btnBuy && priceText) { const span = btnBuy.querySelector('span'); if (span) span.textContent = 'Acquista ora — ' + priceText; }
  const stickybtn = document.querySelector('.sticky-btn');
  if (stickybtn && priceText) stickybtn.textContent = 'Acquista — ' + priceText;
  renderBundleColors(qty);
}

/* Tabs */
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const panel = document.getElementById('tab-' + btn.dataset.tab);
    if (panel) panel.classList.add('active');
  });
});

/* Sticky CTA */
const stickyCta = document.querySelector('.sticky-cta');
const infoCol = document.querySelector('.info-col');
if (stickyCta && infoCol) {
  const stickyIO = new IntersectionObserver((entries) => {
    entries.forEach(e => stickyCta.classList.toggle('visible', !e.isIntersecting));
  }, { threshold: 0 });
  stickyIO.observe(infoCol);
}

/* Sticky btn scroll to top of product */
const stickyBtn = document.querySelector('.sticky-btn');
if (stickyBtn) {
  stickyBtn.addEventListener('click', () => {
    const target = document.getElementById('acquista') || document.querySelector('.product-main');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  });
}

/* Reviews carousel arrows */
const carousel = document.getElementById('revCarousel');
if (carousel) {
  const cardW = () => (carousel.querySelector('.rcard')?.offsetWidth || 300) + 18;
  document.getElementById('revNext')?.addEventListener('click', () => carousel.scrollBy({ left: cardW() * 2, behavior: 'smooth' }));
  document.getElementById('revPrev')?.addEventListener('click', () => carousel.scrollBy({ left: -cardW() * 2, behavior: 'smooth' }));
}

/* Star picker */
const picks = document.querySelectorAll('.star-pick');
let rating = 0;
picks.forEach(s => {
  s.addEventListener('mouseenter', () => picks.forEach(p => p.classList.toggle('lit', p.dataset.v <= s.dataset.v)));
  s.addEventListener('mouseleave', () => picks.forEach(p => p.classList.toggle('lit', p.dataset.v <= rating)));
  s.addEventListener('click', () => {
    rating = +s.dataset.v;
    picks.forEach(p => p.classList.toggle('lit', p.dataset.v <= rating));
  });
});

/* Review submit */
document.getElementById('submitRev')?.addEventListener('click', () => {
  document.getElementById('reviewSuccess')?.classList.add('show');
  const btn = document.getElementById('submitRev');
  if (btn) btn.style.display = 'none';
});

/* Rating bars animate on scroll */
const barIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.querySelectorAll('.rating-fill').forEach(bar => {
        bar.style.transform = `scaleX(${bar.dataset.fill || 1})`;
      });
      barIO.unobserve(e.target);
    }
  });
}, { threshold: 0.3 });
const revSection = document.querySelector('.reviews-section');
if (revSection) barIO.observe(revSection);

/* Buy Now — aggiunge al carrello e va direttamente al checkout */
async function buyNow() {
  const form = document.getElementById('product-form');
  if (!form) return;
  const btn = document.getElementById('btnBuyNow');
  if (btn) { btn.disabled = true; btn.querySelector('span').textContent = 'Caricamento...'; }
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (res.ok) {
      window.location.href = '/checkout';
    } else {
      const err = await res.json();
      alert(err.description || 'Errore. Riprova.');
      if (btn) { btn.disabled = false; btn.querySelector('span').textContent = 'Acquista ora'; }
    }
  } catch {
    if (btn) { btn.disabled = false; btn.querySelector('span').textContent = 'Acquista ora'; }
  }
}

/* ════════════════════════════════
   SHOPIFY CART AJAX
   ════════════════════════════════ */
const addToCartForm = document.getElementById('product-form');
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = addToCartForm.querySelector('[type="submit"]');
    if (!btn) return;
    const origText = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Aggiunta...';
    btn.disabled = true;
    try {
      const formData = new FormData(addToCartForm);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (res.ok) {
        btn.innerHTML = '✓ Aggiunto al carrello!';
        btn.disabled = false;
        const viewCartBtn = document.getElementById('btnViewCart');
        if (viewCartBtn) viewCartBtn.style.display = 'inline-flex';
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCount = document.getElementById('cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
        setTimeout(() => { btn.innerHTML = origText; }, 2500);
      } else {
        const errData = await res.json();
        btn.innerHTML = origText;
        btn.disabled = false;
        alert(errData.description || 'Errore durante l\'aggiunta al carrello.');
      }
    } catch {
      btn.innerHTML = origText;
      btn.disabled = false;
    }
  });
}
